<template>
    <div class="w100">
        <article class="wContent center">
            <el-row :gutter="20">
                <el-col :span="16">
                    <div class="grid-content" style="padding-top: 10px;">
                        <div class="mw-fast-list-box">
                            <span class="mw-fast-list-sub fontBold fontRed">快讯</span>
                            <span class="mw-fast-list-sub" v-for="(item, index) in inforTab_list" :key="index" @click="changeInforTab(item)">{{ item.type_name }}</span>
                        </div>

                        <div class="grid-content mw-modular-box">
                            <div class="bgWhite p10 textRight" style="min-height: 1460px;">
                                <!-- 搜索部分 start -->
                                <div class="mw-search-box">
                                    <div class="mw-search-keybox inlineBlock">
                                        <el-input placeholder="搜索" v-model="keyword" clearable @blur="newflashFindList(1)"></el-input>
                                    </div>
                                    <div class="mw-search-daybox inlineBlock">
                                        <el-date-picker v-model="date" type="date" value-format="yyyy-MM-dd" @change="newflashFindList(1)" :clearable="false"></el-date-picker>
                                        <span class="value">日期</span>
                                    </div>
                                </div>
                                <!-- 搜索部分 end -->

                                <!-- 列表部分1 start -->
                                <div class="part-1 p10 fontLighter">
                                    <div v-show="isHasFlashList">
                                        <div class="part-main textLeft" v-for="(item, index) in newflash_list" :key="index">
                                            <span class="part-date font18 fontNormal">{{ item.date ? (item.date + '，' + item.week) : '' }}</span>
                                            <div v-for="(cItem, cIndex) in item.list" :key="cIndex">

                                                <div class="part-list bgGrey">
                                                    <el-row>
                                                        <el-col :span="3">
                                                            <div class="grid-content part-list-time font18 textCenter">
                                                                {{ cItem.time }}
                                                            </div>
                                                        </el-col>
                                                        <el-col :span="21">
                                                            <div class="grid-content part-list-main fontLight">
                                                                {{ cItem.newsTxt }}
                                                            </div>
                                                        </el-col>
                                                    </el-row>
                                                </div>
                                                <div class="ad mw-modular-box" v-show="cIndex * (index+1) == 4 && adIDsIndex[1] && adIDsIndex[1]['list'].length > 0" style="margin: 10px 0 10px 0">
                                                    <a :href="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adLink'] : '') : ''" target="_blank">
                                                        <img :src="adIDsIndex[1] ? (adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adPicturePath'] : '') : ''" alt="" style="height: 100px;" class="w100">
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="!isHasFlashList" class="textCenter font14">暂无快讯信息</div>

                                    <div class="textRight bgWhite" style="padding-top: 10px;" v-show="newflash_list.length > 0">
                                        <el-pagination background @current-change="handleCurrentChange" :current-page="pagenum" :page-size="pernum" layout="total, prev, pager, next, jumper" :total="totalnum"></el-pagination>
                                    </div>
                                </div>
                                <!-- 列表部分1 end -->
                                <div class="textCenter mw-modular-box font14" v-show="newflash_list.length == 0">暂无数据</div>
                            </div>
                            <!-- 列表部分2 end -->

                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <div class="varieties-box bgWhite" style="margin-top: 10px;">
                            <h4>
                                <span class="font14 block">品种报告</span>
                                <span class="block textRight"><a class="fontDark pointer font14" @click="goReportPage('')">更多+</a></span>
                            </h4>
                            <div class="varieties-list">
                                <span v-for="(item, index) in reportClassify" :key="index" @click="goReportPage(item.sortId)"><a class="fontWhite pointer">{{ item.sortName }}</a></span>
                            </div>
                        </div>

                        <MapControl></MapControl>

                        <PriceIndexControl class="mw-modular-box"></PriceIndexControl>

                        <HotRecord class="mw-modular-box" :ad="adIDsIndex[0] ? ( adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adPicturePath'] : '') : ''" :link="adIDsIndex[0] ? ( adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adLink'] : '') : ''"></HotRecord>

                    </div>
                </el-col>
            </el-row>
            
            
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import ConcatsControl from '../../templates/concatsControl'
import MapControl from '../../templates/mapControl'
import PriceIndexControl from '../../templates/priceIndexControl'
import HotRecord from '../../templates/hotRecord'
import $ from 'jquery'
import { baseUrl, adIDs, navigationUrl } from '../../assets/js/common'
export default {
    name: 'InforFastList',
    components: { MapControl, PriceIndexControl, HotRecord, ConcatsControl },
    data () {
        return {
            adIDsIndex: [],
            inforTab_list: [],
            keyword: '',
            date: '',
            isHasFlashList: true,
            newflash_list: [],
            pagenum: 1,
            pernum: 11,
            totalnum: 0,
            reportClassify: [],
            navigationUrl: navigationUrl,
        }
    },
    mounted () {
        // 初始化内容
        this.findNewsClassify();
        this.newflashFindList();
        this.getAdByAdp();
        this.findReportSortByUserFormat();
    },
    methods: {
        //页面操作
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex = [{
                name: 'indexRight2',
                id: adIDs['indexRight2'],
                list: []
            }, {
                name: 'zx40',
                id: adIDs['zx40'],
                list: []
            }];
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },
/* ***** 获取资讯分类 start ******************************* */
        findNewsClassify () {
            const self = this;
            $.ajax({
                url: `${baseUrl.service}/api_v3/news_classify?pagenum=1&pernum=99`,
                data: {},
                type: 'get',
                dataType: 'json',
                success: (res) => {
                    if (res.code == 'ok') {
                        self.inforTab_list = [];
                        res.data.forEach((item, index) => {
                            if (item.the_level == 1 && item.is_valid == 'Y') {
                                self.inforTab_list.push(item);
                            }
                        })
                    } else {
                        self.$message.error(res.message);
                    }
                },
                error: () => {
                    self.$message.error('未获取到资讯分类信息')
                }
            })
        },
/* ***** 获取资讯分类 end ******************************** */

/* ***** 查询快讯信息 start ****************************** */
        /*  */
        // 快讯查询
        newflashFindList (type) {
            const self = this;
            self.newflash_list = [];
            type ? self.pagenum = 1 : '';
            self.$post(`${baseUrl.cyw}/newflash/findList/${self.pagenum}/${self.pernum}`, {date: self.date, newsTxt: self.keyword}).then(res => {
                if (res.code == 0) {
                    if (res.data.length > 0) {
                        self.isHasFlashList = true;
                        let arr = [];
                        let dateArr = [];
                        res.data.forEach((item, index) => {
                            if (index == 0) {
                                dateArr.push(item.newsDate.substr(0, 10));
                            } else {
                                const j = dateArr.length - 1;
                                if (item.newsDate.substr(0, 10) != dateArr[j]) {
                                    dateArr.push(item.newsDate.substr(0, 10));
                                }
                            }                                
                        })
                        dateArr.forEach((item, index) => {
                            let obj = {
                                sdate: '',
                                date: item,
                                week: self.getWeek(item),
                                list: []
                            }
                            res.data.forEach((cItem, cIndex) => {
                                if (cItem.newsDate.substr(0, 10) == item) {
                                    obj.sdate =  cItem.newsDate;
                                    cItem.time = cItem.newsDate.substr(11, 5);
                                    obj.list.push(cItem);
                                }
                            })
                            arr.push(obj);
                        })
                        self.newflash_list = arr;
                        self.totalnum = res.totalCount;
                    } else {
                        self.newflash_list[0] = {sdate: '', date: '', week: '', list: []};
                    }
                }else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('未获取到快讯信息');
            })
        },
        /* 分页 */
        handleCurrentChange (page) {
            this.pagenum = page;
            this.newflash_list = [];
            this.newflashFindList();
        },
        /* tab切换 */
        changeInforTab (item) {
            this.$router.push(`/home/inforList/${item.type_name}`)
        },

/* ***** 获取报告分类 - 唐宋100指数报告-分品种 下的分类 start ****************************** */

        findReportSortByUserFormat () {
            const self = this;
            self.$get(`${baseUrl.online}/industria/reportSort/findReportSortByUserFormat`, {}).then(res => {
                if(res.code == 0) {
                    res.data.forEach((item, index) => {
                        if (item.childs.length > 0) {
                            self.reportClassify = item.childs;
                        }
                    })
                }else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('未获取到报告分类信息');
            })
        },

/* ***** 获取报告分类 - 唐宋100指数报告-分品种 下的分类 end ******************************** */
        goReportPage (id) {
            // console.log(navigationUrl['研报'])
            this.$router.push(`${navigationUrl['研报']}?sortId=${id}`)
        },

        // 判断今天周几
        getWeek (date) {
            const new_date = new Date(date);
            const weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            const day = new_date.getDay();
            return weeks[day];
        }

    },
}
</script>

<style scoped>
</style>